import { createTheme } from '@mui/material/styles';
import { defaultTheme } from 'react-admin';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1E2A3A',
      light: '#2D3448',
      dark: '#111820',
    },
    secondary: {
      main: '#E8461C',
      light: '#F06A3E',
      dark: '#C23814',
    },
    background: {
      default: '#F5F4F1',
    },
  },
  overrides: {
    MuiTableHead: {
      root: {
        backgroundColor: '#E5E4DF',
        width: '100%',
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: 'none',
      },
      root: {
        border: '1px solid #e0e0e3',
        backgroundClip: 'padding-box',
      },
    },
  },
  sidebar: {
    width: 270,
  },
  components: {
    ...defaultTheme.components,
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          borderLeft: '3px solid #fff',
          '&.RaMenuItemLink-active': {
            borderLeft: '3px solid #E8461C',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#E8461C',
          '&:hover': {
            backgroundColor: '#C23814',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#1E2A3A',
        },
      },
    },
  },
});